// @flow
import flatten from 'lodash/flatten'
import type { School } from 'types'
import type { ProfileEnrollment } from 'types/profile'

export const SCHOOL_LICENSE_TYPE_SMALL = 'small'
export const SCHOOL_LICENSE_TYPE_LARGE = 'large'
export const SCHOOL_LICENSE_TYPE_FOREST = 'forest'

export const SCHOOL_PROGRAM_TYPE_PRESCHOOL = 'preschool'
export const SCHOOL_PROGRAM_TYPE_FOREST = 'forest'
export const SCHOOL_PROGRAM_TYPE_CHILD_CARE = 'child_care'

export const SCHOOL_TIMEZONE_LOS_ANGELES = 'America/Los_Angeles'
export const SCHOOL_TIMEZONE_DENVER = 'America/Denver'
export const SCHOOL_TIMEZONE_PHOENIX = 'America/Phoenix'
export const SCHOOL_TIMEZONE_CHICAGO = 'America/Chicago'
export const SCHOOL_TIMEZONE_NEW_YORK = 'America/New_York'

export const SCHOOL_TIMEZONE_OPTIONS = [
  SCHOOL_TIMEZONE_LOS_ANGELES,
  SCHOOL_TIMEZONE_DENVER,
  SCHOOL_TIMEZONE_PHOENIX,
  SCHOOL_TIMEZONE_CHICAGO,
  SCHOOL_TIMEZONE_NEW_YORK,
]

export function schoolProgramTypeToHuman(programType: string): string {
  switch (programType) {
    case SCHOOL_PROGRAM_TYPE_PRESCHOOL:
      return 'Preschool'
    case SCHOOL_PROGRAM_TYPE_FOREST:
      return 'Forest School'
    case SCHOOL_PROGRAM_TYPE_CHILD_CARE:
      return 'Child Care'
    default:
      return ''
  }
}

export function humanReadableTimeZone(timezone: string): string {
  switch (timezone) {
    case SCHOOL_TIMEZONE_LOS_ANGELES:
      return 'Pacific Time'
    case SCHOOL_TIMEZONE_DENVER:
      return 'Mountain Time'
    case SCHOOL_TIMEZONE_PHOENIX:
      return 'Mountain Time, Arizona'
    case SCHOOL_TIMEZONE_CHICAGO:
      return 'Central Time'
    case SCHOOL_TIMEZONE_NEW_YORK:
      return 'Eastern Time'
    default:
      return ''
  }
}

export type PriceRange = {
  min: number,
  max: number,
}

export function tuitionPriceRange(school: School) {
  return tuitionPriceRangeFromProfileEnrollment(school.profile && school.profile.enrollment)
}

export function tuitionPriceRangeFromProfileEnrollment(
  enrollment: ?ProfileEnrollment,
): ?PriceRange {
  const schedules = (enrollment && enrollment.schedules) || []
  const rates = flatten(schedules.map(schedule => schedule.rates))

  let min
  let max

  rates.forEach(rate => {
    if (!rate.amount) return

    const str = rate.amount
    const val = parseFloat(str.replace(/[$,]/g, ''))

    if (!min || val < min) {
      min = val
    }

    if (!max || val > max) {
      max = val
    }
  })

  return min && max && { min, max }
}
